"use client";

import { track } from "@lib/track";
import { relForExternal } from "@/app/lib/affiliateLinks";

// Outbound link to Unicity. Not TrackedLink: that renders next/link with a plain
// security rel, and an affiliate destination must carry `sponsored` (see
// affiliateLinks.ts). The disclosure copy lives on the page beside every one of these.
export default function AffiliateCta({
  href,
  label,
  className,
  children,
}: {
  href: string;
  label: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel={relForExternal(href)}
      className={className}
      onClick={() => {
        try {
          track(
            "cta_click",
            { label, component: "InsulinResistancePage" },
            { event: "cta_click", label, component: "InsulinResistancePage", meta: { outbound: href } }
          );
        } catch {
          // silent fail
        }
      }}
    >
      {children}
    </a>
  );
}
